import { Media } from "./media";

export interface AthleteTeam {
    id: number;
    name: string;
    club_id: number;
    club_name: string;
}

export interface AthleteTeamSeason {
    id: number;
    athlete_id: number;
    athlete_name: string;
    team_id: number;
    team_name: string;
    season_id: number;
    season_name: string;
    club_id: number;
    club_name: string;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
    current: boolean;
}

export const emptyAthleteTeamSeason: AthleteTeamSeason = {
    id: 0,
    athlete_id: 0,
    athlete_name: '',
    team_id: 0,
    team_name: '',
    season_id: 0,
    season_name: '',
    club_id: 0,
    club_name: '',
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: '',
    current: false
}

export interface AthleteMeasurement {
    id: number;
    athlete_id: number;
    measurement_date: string;
    weight: number;
    height: number;
    bmi: number;
    fm: number;
    bm: number;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyAthleteMeasurement: AthleteMeasurement = {
    id: 0,
    athlete_id: 0,
    measurement_date: '',
    weight:0,
    height:0,
    bmi: 0,
    fm: 0,
    bm: 0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

export interface AthleteRanking {
    id: number;
    athlete_id: number;
    ranking_date: string;
    points: number;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyAthleteRanking: AthleteRanking = {
    id: 0,
    athlete_id: 0,
    ranking_date: '',
    points:0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

export interface AthletePerformance {
    id: number;
    athlete_id: number;
    performance_date: string;
    perf1: number;
    perf2: number;
    perf3: number;
    perf4: number;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyAthletePerformance: AthletePerformance = {
    id: 0,
    athlete_id: 0,
    performance_date: '',
    perf1:0,
    perf2:0,
    perf3:0,
    perf4:0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

export interface Athlete {
    id: number;
    user_id: number;
    name: string;
    email: string;
    first_name: string;
    last_name: string;
    birthdate: string;
    phone: string;
    document_id: string;
    description: string;
    avatar: Media[];
    birth_city: string;
    birth_region: string;
    birth_country: string;
    city: string;
    region: string;
    country: string;
    address: string;
    sex: string;
    registered_in: AthleteTeamSeason[];
    measurement: AthleteMeasurement[];
    ranking: AthleteRanking[];
    performance: AthletePerformance[];
    teams: AthleteTeam[];
    status: number;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyAthlete: Athlete = {
    id: 0,
    user_id: 0,
    name: '',
    email: '',
    first_name: '',
    last_name: '',
    birthdate: '',
    phone: '',
    document_id: '',
    description: '',
    avatar: [],
    birth_city: '',
    birth_region: '',
    birth_country: '',
    city: '',
    region: '',
    country: '',
    address: '',
    sex: '',
    registered_in: [],
    measurement: [],
    ranking: [],
    performance: [],
    teams: [],
    status: 0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}
